import { PersonHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const DeleteCustomMessageData = (personCustomInboxId, state, setState) => {
  if (state.isObjLoading !== true && !state.message) {
    const newState = {
      ...state,
      isObjLoading: true,
      isObjLoaded: false,
      message: 'Deleting...'
    };
    setState(newState);

    const personCustomInboxIdForUrl = personCustomInboxId ? encodeURIComponent(personCustomInboxId) : 'NaN';
    const url = `/PersonCustomInbox/${personCustomInboxIdForUrl}`;
    PersonHttpHelper(url, 'DELETE')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            objData,
            isObjLoading: false,
            isObjLoaded: true,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoading: false,
          isObjLoaded: false,
          message: message
        });
      });
  }
};

export default DeleteCustomMessageData;